<template>
  <div nav-clear
       class="congress-back-color help-page" v-if="showHelp">
    <div style="margin-top:env(safe-area-inset-top) !important;">
      <div translate="APP_LOGIN" style="text-align: left;font-size: 0.9rem">
      </div>
      <br>

      <div style="width:100%;" v-if="loaded">
        <!-- Using the slider component -->
        <carousel :items-to-show="1" style="background-color: #642482">
          <slide style="height: 85vh; background-color: #dfdaed">
            <font-awesome-icon :icon="['far','times-circle']" style="font-size: 2rem; position: absolute; top:5px; right:5px" @click="loginClicked()"></font-awesome-icon>
            <div class="px-3" style="height: 100%">
              <div class="my-4" style="font-size: 1.6rem; line-height: 1.7rem">Welcome to the Euroanaesthesia 2024 app</div>
              <p>Swipe through the tutorial screens to learn more about how to use the app.</p>
            </div>

          </slide>
          <slide v-for="slide in 8" :key="slide" style="height: 85vh; background-color: #dfdaed">
            <font-awesome-icon :icon="['far','times-circle']" style="font-size: 2rem; position: absolute; top:5px; right:5px" @click="loginClicked()"></font-awesome-icon>
            <div class="px-3 mt-5" style="height: 100%">
                <img :src="'/assets/helpimages/slide'+ slide + '.png'" class="py-2" :style="{'height': slide < 8 ? '90%' : '90%'}">
              <div style="border: none;" v-if="slide == 8">
                <button class="btn ms-2" @click="loginClicked()" style="background-color: #642482; color:#fff">
                  Let´s Go
                </button>
              </div>
              <div v-else>Please swipe</div>
            </div>

          </slide>

          <template #addons>
            <pagination/>
          </template>
        </carousel>
      </div>
    </div>
  </div>

</template>
<script>
import {defineComponent} from 'vue';
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";

const config = require('@/config')
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Slide, Pagination, Navigation} from 'vue3-carousel'


export default defineComponent({
  name: 'Splash',
  data() {
    return {
      pass: '',
      isError: false,
      error: '',
      show: false,
      loaded: false,
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('splashscreen', ['showHelp']),
  },
  methods: {
    ...mapActions('banners', ['getForState']),
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions("files", [
      "getImage",
    ]),
    ...mapMutations("splashscreen", [
      "setShowHelp"
    ]),

    getStyle(splash) {
      return {
        'background-image': 'url(' + splash || '' + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'contain'
      }
    },
    loginClicked() {
      localStorage.setItem('helpSeen', true);
      this.isError = false;
      this.setShowHelp(false)
    },
    async showHelp() {
      this.show = true
    },


    async initHelp() {
      let helpseen = localStorage.getItem('helpSeen') || '';
      let consentAnswered = localStorage.getItem('consentGiven');

      if (helpseen == 'true' || !consentAnswered) {
        this.setShowHelp(false)
      } else {
        this.setShowHelp(true)
      }
    }
  },
  async created() {
    await this.initHelp();
    this.loaded = true;
  },
  watch: {
    showHelp: async function (newVal) {
      if (newVal == true) {
        console.log('showit', newVal)
        await this.initHelp()
      } else {
        console.log('no newval')
      }
    },
  }
});
</script>
<style lang="scss" scoped>
#password {
  position: absolute;
  background-color: white !important;
  z-index: 1040; //999;
  width: 100%;
  height: 100%;

}

.help-page {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: #002a32;
  z-index: 100000000;
  display: inline-block;
  text-align: center;
  border: solid 15px #002a32;
}

.carousel__pagination{
  padding: 0;
}
</style>
